import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "./Breadcrumb";
import { Link } from "react-router-dom";
import { HOME } from "../../lib/routesResolver";
import React from "react";

const BreadcrumbPanel = ({ items }) => {
  return (
    <Breadcrumb>
      <BreadcrumbList>
        <BreadcrumbItem>
          <BreadcrumbLink asChild>
            <Link to={HOME}>Inicio</Link>
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbSeparator />
        {items &&
          items.map((item, index, arr) => {
            if (index + 1 === arr.length) {
              return (
                <BreadcrumbItem key="final_breadcrumb_item">
                  <BreadcrumbPage>{item.title}</BreadcrumbPage>
                </BreadcrumbItem>
              );
            } else {
              return (
                <React.Fragment key={`breadcrum_item_${index}`}>
                  <BreadcrumbItem>
                    <BreadcrumbLink asChild>
                      <Link to={item.link}>{item.title}</Link>
                    </BreadcrumbLink>
                  </BreadcrumbItem>
                  <BreadcrumbSeparator />
                </React.Fragment>
              );
            }
          })}
      </BreadcrumbList>
    </Breadcrumb>
  );
};

export default BreadcrumbPanel;
